import React, { ReactElement } from 'react';
import { useAvigilonCamerasHandoff } from './useAvigilonCamerasHandoff';

export function CamerasContainer(): ReactElement {
  const openHandoff = useAvigilonCamerasHandoff();
  const [hasError, setHasError] = React.useState(false);

  // Direct visits to `/cameras` (bookmarks, the sidebar link's graceful-degradation
  // href) have no user gesture to open a new tab from, so redirect the current tab.
  // `useAvigilonCamerasHandoff` uses `location.replace` here so the back button skips
  // this interstitial. The sidebar link opens Avigilon in a new tab (see sc-17102).
  const redirect = React.useCallback((): void => {
    setHasError(false);
    openHandoff({ openInNewTab: false }).catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Avigilon cameras handoff failed', error);
      setHasError(true);
    });
  }, [openHandoff]);

  React.useEffect(() => {
    redirect();
  }, [redirect]);

  if (hasError) {
    return (
      <div className="odin-p-6 odin-flex odin-flex-col odin-items-start odin-gap-3">
        <p>We couldn&apos;t open the cameras. Please try again.</p>
        <button
          type="button"
          className="odin-text-odin-primary odin-underline"
          onClick={redirect}
        >
          Try again
        </button>
      </div>
    );
  }

  return <div>Redirecting ...</div>;
}
